import { Check } from "lucide-react";
import { cn } from "../../lib/util";
import { BookingStep } from "../../types/booking";

interface BookingProgressProps {
  step: BookingStep;
}

const STEPS: { key: BookingStep; label: string }[] = [
  { key: "location", label: "Your details" },
  { key: "schedule", label: "Date & time" },
];

export function BookingProgress({ step }: BookingProgressProps) {
  const currentIndex = STEPS.findIndex((s) => s.key === step);

  return (
    <nav aria-label="Booking progress">
      <ol className="flex items-center gap-3">
        {STEPS.map((s, i) => {
          const isDone = i < currentIndex;
          const isCurrent = i === currentIndex;
          return (
            <li key={s.key} className="flex flex-1 items-center gap-3">
              <span
                aria-current={isCurrent ? "step" : undefined}
                className="flex items-center gap-2.5"
              >
                <span
                  className={cn(
                    "flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-sm tabular-nums transition-colors",
                    isDone && "border-[#B87775] bg-[#B87775] text-white",
                    isCurrent && "border-[#B87775] text-[#B87775]",
                    !isDone && !isCurrent && "border-[#E3C9C8] text-[#bcaca9]"
                  )}
                >
                  {isDone ? (
                    <Check className="h-4 w-4" aria-hidden="true" />
                  ) : (
                    i + 1
                  )}
                </span>
                <span
                  className={cn(
                    "whitespace-nowrap text-sm transition-colors",
                    isCurrent ? "text-[#3a2e2c]" : "text-[#9A6B69]"
                  )}
                >
                  {s.label}
                  {isDone && <span className="sr-only"> (completed)</span>}
                </span>
              </span>

              {/* Connector */}
              {i < STEPS.length - 1 && (
                <span className="h-px flex-1 overflow-hidden rounded-full bg-[#EAD7D6]">
                  <span
                    className="block h-full bg-[#B87775] transition-all duration-500"
                    style={{ width: i < currentIndex ? "100%" : "0%" }}
                  />
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
